import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RelationshipLevelRes } from "@api/relationshipLevel";

export type RelationshipLevelState = {
  data: RelationshipLevelRes[];
  isLoading: boolean;
  error: string;
};

const initialState: RelationshipLevelState = {
  data: [],
  isLoading: false,
  error: "",
};

export const relationshipLevelSlice = createSlice({
  name: "relationshipLevel",
  initialState,
  reducers: {
    setRelationshipLevels: (
      state,
      { payload }: PayloadAction<RelationshipLevelRes[]>
    ) => {
      state.data = payload;
      state.isLoading = false;
    },
    setRelationshipLevelsLoading: (state) => {
      state.isLoading = true;
      state.error = "";
    },
    setRelationshipLevelsError: (
      state,
      { payload }: PayloadAction<string>
    ) => {
      state.isLoading = false;
      state.error = payload;
    },
    resetRelationshipLevels: (state) => {
      state.data = initialState.data;
      state.isLoading = initialState.isLoading;
      state.error = initialState.error;
    },
  },
});

export const {
  setRelationshipLevels,
  setRelationshipLevelsLoading,
  setRelationshipLevelsError,
  resetRelationshipLevels,
} = relationshipLevelSlice.actions;

export default relationshipLevelSlice.reducer;
